import React, { useState, useEffect } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { userBusinessListRequest } from '../../../redux/business/business.action'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import { chatListRequest, chatSendMessageRequest, chatSendMessageRequestStatus } from '../../../redux/chat/chat.action'
import { employeeListRequest } from '../../../redux/employee/employee.action'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull } from "../../../utils/Utils";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import Select from 'react-select'
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Modal from 'react-bootstrap/Modal';
import CommonButton from "../../../components/button/common-button/commonButton";
import { Checkbox, FormControlLabel } from '@mui/material';
import ColoredCircle from "../../../components/colored-circle/coloredCircle";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import { SentimentSatisfiedAlt } from "@mui/icons-material";

const MessageChatList = props => {
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { chatListSuccess, chatListError, chatSendMessageSuccess, chatSendMessageError, chatSendMessageReqStatus } = useSelector((state) => state.chat)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const [displayEmployeeModal, setDisplayEmployeeModal] = useState(false)
    const [chatEmployeeList, setChatEmployeeList] = useState([])
    const [message, setMessage] = useState('')
    const [groupName, setGroupName] = useState('')
    const [displayGroupName, setDisplayGroupName] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const [selectedEmployees, setSelectedEmployees] = useState([])
    const [filteredEmpList, setFilteredEmpList] = useState([])

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            setLoading(true)
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.MESSAGE_CHAT_LIST, true)
            const data = {
                userId: user.data.userDetails.userId
            }
            dispatch(userBusinessListRequest(data))
        } else {
            fetchChatList()
        }
    }, [])

    const fetchChatList = () => {
        setLoading(true)
        const data = {
            userType: user.data.userDetails.userType,
            businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
            userId: isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
        }
        dispatch(chatListRequest(data))
    }

    useEffect(() => {
        if (!isNull(chatListSuccess)) {
            setLoading(false)
        } else if (!isNull(chatListError)) {
            setLoading(false)
        }
    }, [chatListSuccess, chatListError])

    useEffect(() => {
        if (chatSendMessageReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(chatSendMessageSuccess.message)
            fetchChatList()
        } else if (chatSendMessageReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(chatSendMessageError.message)
        }
        if (chatSendMessageReqStatus.length) {
            dispatch(chatSendMessageRequestStatus(''))
        }
    }, [chatSendMessageSuccess, chatSendMessageError, chatSendMessageReqStatus])

    useEffect(() => {
        if (!isNull(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.MESSAGE_CHAT_LIST) === 'true') {
                sessionStorage.removeItem(APP_CONSTANTS.SCREEN.MESSAGE_CHAT_LIST)
                if (!isNull(userBusinessListSuccess.data))
                    setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isNull(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isNull(employeeListSuccess)) {
            setLoading(false)
            let empList = []
            employeeListSuccess.data.forEach(e => {
                empList.push({
                    ...e,
                    selected: false
                })
            });
            setSelectedEmployees(empList)
            setFilteredEmpList(empList)
        } else if (!isNull(employeeListError)) {
            setLoading(false)
            setSelectedEmployees([])
        }
    }, [employeeListSuccess, employeeListError])

    const fetchEmployeeList = (businessId) => {
        const data = {
            businessId: businessId
        }
        setLoading(true)
        dispatch(employeeListRequest(data))
    }

    const handleSelectEmployee = () => {
        setLoading(true)
        setSelectedEmployees([])
        if (isLoggedInUserEmployee(user)) {
            fetchEmployeeList(employeeSelectedBusiness)
        }
        if (isLoggedInUserBusiness(user)) {
            fetchEmployeeList(selectedBusiness.businessId)
        }
        setDisplayEmployeeModal(true)
    }

    const handleSelectEmployeeClick = (item) => {
        let usrBusinessId = isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness
        const updatedList = selectedEmployees.map(e => {
            let mappingObjExisting = e.employeeBusinessMapping.find(obj => parseFloat(obj.businessId) === parseFloat(usrBusinessId))
            let mappingObjNew = item.employeeBusinessMapping.find(obj => parseFloat(obj.businessId) === parseFloat(usrBusinessId))
            if (!isEmpty(mappingObjExisting) && !isEmpty(mappingObjNew)) {
                if (mappingObjExisting.employeeCode === mappingObjNew.employeeCode) {
                    return {
                        ...e,
                        selected: e.selected === true ? false : true
                    }
                } else {
                    return e
                }
            } else {
                return e
            }
        })
        // const updatedList = selectedEmployees.map((e) => e.employeeCode === item.employeeCode ? { ...e, selected: e.selected === true ? false : true } : e)
        setSelectedEmployees(updatedList)
        setFilteredEmpList(updatedList)
        setSearchQuery('')
    }

    const handleSendMessage = () => {
        let isSelected = false
        let selectedEmpList = []
        let count = 0
        chatEmployeeList.forEach(e => {
            if (e.checked === true) {
                isSelected = true
                selectedEmpList.push(e)
                count = Number(count) + 1
            }
        }
        )
        const selectedEmps = selectedEmployees.filter(e => e.selected === true)
        if (isEmpty(selectedEmps)) {
            displayErrorToast('No employee selected to message')
        } else if (isEmpty(message)) {
            displayErrorToast('Message cannot be blank')
        } else if (selectedEmps.length > 1 && isEmpty(groupName)) {
            displayErrorToast('Group name cannot be blank')
        } else {
            const data = {
                message: message,
                senderId: user.data.userDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.BUSINESS ? user.data.userDetails.userId : user.data.userDetails.employeeId,
                userType: user.data.userDetails.userType,
                productCode: APP_CONSTANTS.PRODUCT_NAME
            }
            let receivers = []
            selectedEmps.forEach(e => {
                receivers.push({
                    id: e.userType === APP_CONSTANTS.USER_ROLE_TYPE.BUSINESS ? e.userId : e.employeeId,
                    type: e.userType
                })
            })
            data.receivers = receivers
            if (selectedEmps.length > 1) {
                data.chatType = APP_CONSTANTS.CHAT_TYPE.GROUP
                data.groupName = groupName
            } else {
                data.chatType = APP_CONSTANTS.CHAT_TYPE.INDIVIDUAL
            }
            if (isLoggedInUserEmployee(user)) {
                data.businessId = employeeSelectedBusiness
            }
            if (isLoggedInUserBusiness(user)) {
                data.businessId = selectedBusiness.businessId
            }
            setDisplayEmployeeModal(false)
            setLoading(true)
            dispatch(chatSendMessageRequest(data))
        }
    }

    const getInitials = (empList, groupName, type) => {
        let words
        if (type === APP_CONSTANTS.CHAT_TYPE.GROUP) {
            words = groupName.split(" ");
        } else if (type === APP_CONSTANTS.CHAT_TYPE.INDIVIDUAL) {
            console.log('emp', empList)
            const empObj = empList.filter(e => e.userId !== user.data.userDetails.userId)
            const name = `${empObj[0].firstName} ${empObj[0].lastName}`
            words = name.split(" ");
        }
        const tempInitials = words.map(word => word.charAt(0)).join("");
        const initials = tempInitials.toUpperCase();
        return initials
    }

    const getName = (empList, groupName, type) => {
        if (type === APP_CONSTANTS.CHAT_TYPE.GROUP) {
            return groupName
        } else if (type === APP_CONSTANTS.CHAT_TYPE.INDIVIDUAL) {
            const empObj = empList.filter(e => e.userId !== user.data.userDetails.userId)
            const name = `${empObj[0].firstName} ${empObj[0].lastName}`
            return name
        }
    }

    const chatItemClick = (item) => {
        console.log('item', item)
        navigate(ROUTES.messageList, {
            state: {
                chat: item,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness
            }
        })
    }

    useEffect(() => {
        if (!isEmpty(selectedEmployees)) {
            const selEmp = selectedEmployees.filter(e => e.selected === true)
            if (selEmp.length > 1) {
                setDisplayGroupName(true)
            } else {
                setDisplayGroupName(false)
            }
        }
    }, [selectedEmployees])

    const handleSearchClick = () => {
        const items = selectedEmployees.filter(e => {
            if (!searchQuery.trim()) return true; // Return all employees if searchQuery is empty

            return (
                e.firstName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                e.lastName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                e.employeeCode?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        });
        setFilteredEmpList(items)
    }

    useEffect(() => {
        if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness)) {
            fetchChatList()
        }
    }, [selectedBusiness])

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Chat List' />
                {isLoggedInUserBusiness(user) === true && <div className="margin-bottom-10">
                    <FormFieldLabel className='up-bold-label' label='Select Business' />
                    {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                        className='select-full-width-no-border'
                        value={selectedBusiness}
                        getOptionLabel={e => e.businessName}
                        getOptionValue={e => e}
                        options={userBusinessListSuccess.data}
                        placeholder='Select Business'
                        onChange={e => setSelectedBusiness(e)} />}
                    {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                </div>}
                {!isNull(chatListSuccess) && !isEmpty(chatListSuccess.data) && <div className="mcl-content-container">
                    {chatListSuccess.data.map(e => (
                        <div className='mcl-row-container' onClick={() => chatItemClick(e)}>
                            <ColoredCircle initials={getInitials(e.usersDetails, e.groupName, e.chatType)} />
                            <div className="mcl-card-title">{getName(e.usersDetails, e.groupName, e.chatType)}</div>
                        </div>
                    ))}
                </div>}
                {!isNull(chatListError) && <div className="content-error">{chatListError.message}</div>}
                <div className="vl-fab-container" onClick={() => handleSelectEmployee()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>
            </CommonScreenContent>
            <Modal
                onHide={() => { setDisplayEmployeeModal(!displayEmployeeModal) }}
                show={displayEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Select Employee
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="ol-search-parent-container">
                        <div className="ol-search-row-parent-container">
                            <div className="ol-search-input-container">
                                <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                            </div>
                            <div className="ol-search-icon-container" onClick={() => { handleSearchClick() }}>
                                <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                            </div>
                        </div>
                    </div>
                    {!isNull(employeeListSuccess) && !isNull(employeeListSuccess.data) && !isEmpty(filteredEmpList) && <div className="mcl-emp-list">
                        {filteredEmpList.map(item => (<div className="mcl-emp-list-item-container">
                            <div className="mcl-emp-lic-content">
                                <div>{item.firstName} {item.lastName}</div>
                                <div>{item.employeeCode}</div>
                            </div>
                            <div className="mcl-emp-lic-icon-container" onClick={() => { handleSelectEmployeeClick(item) }}>
                                {item.selected === true ? (<img src={require('../../../assets/ic_check_icon.png')} className="img" />) :
                                    (<img src={require('../../../assets/ic_uncheck_icon.png')} className="img" />)}
                            </div>
                        </div>))}
                        {/* {chatEmployeeList.map(e => (<FormControlLabel
                            key={e.employeeId}
                            control={
                                <Checkbox
                                    checked={e.checked || false}
                                    onChange={handleCheckboxChange(e.employeeId)}
                                />
                            }
                            label={e.name}
                        />))} */}
                    </div>}
                    {!isNull(employeeListError) && <div className="content-error">{employeeListError.message}</div>}

                    {!isNull(employeeListSuccess) && !isNull(employeeListSuccess.data) && <div className='margin-bottom-10'>
                        <FormFieldLabel label='Type your message below' />
                        <CommonInputFloatFull
                            id='message'
                            onChange={e => setMessage(e.target.value)}
                            placeholder='Message'
                            type='text'
                            value={message}
                            isRequired={true} />
                        {displayGroupName && <CommonInputFloatFull
                            id='groupName'
                            onChange={e => setGroupName(e.target.value)}
                            placeholder='Group Name'
                            type='text'
                            value={groupName}
                            isRequired={true} />}
                    </div>}
                </Modal.Body>
                <Modal.Footer>
                    <CommonButton onClick={() => handleSendMessage()}
                        label='Send' />
                </Modal.Footer>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default MessageChatList